module.exports = __webpack_public_path__ + "img/flag_de.63aafae1.svg";